export default {
  list: [
    {
      value: 'WAITING',
      title: 'در انتظار'
    },
    {
      value: 'REJECTED',
      title: 'رد شده'
    },
    {
      value: 'CONFIRMED',
      title: 'تایید شده'
    }
  ],
  values: {
    WAITING: 'WAITING',
    REJECTED: 'REJECTED',
    CONFIRMED: 'CONFIRMED'
  }
};
